<template>
  <div :class="['mobileMenu', { 'mobileMenu--active': isMenuOpened[menuName] }]">
    <ul :class="['mobileMenu__list', { 'mobileMenu__list--open': !activeMenuItem[menuName] }]">
      <li class="mobileMenu__header">
        Menu
        <button
          class="mobileMenu__headerClose icon-line-close"
          @click="toggleMenu({ type: menuName })"
        />
      </li>
      <li v-if="menuName === 'user'" class="mobileMenu__user">
        <div class="mobileMenu__avatar" />
        <div class="mobileMenu__name">
          {{ `${user.firstName} ${user.lastName}` }}
          <span>{{ user.roleName }}</span>
        </div>
      </li>
      <li v-if="otherAccounts && otherAccounts.length" class="mobileMenu__select">
        <form-multiselect
          :options="
            otherAccounts.map(account => ({
              id: account.userId,
              name: account.companyUserCanSwitchTo.name,
            }))
          "
          :allow-empty="false"
          :value="currentCompany"
          option-label="name"
          key-value="id"
          track-by="id"
          placeholder="Wybierz firme"
          label="Firma"
          @input="val => $emit('switch-account', val)"
        />
      </li>
      <mobile-tree-menu
        v-for="({ name, slug, href, iconClass, children, id, count }, index) in menuItems"
        :key="`${index}_${id}`"
        :label="name"
        :count="count"
        :slug="slug"
        :href="href"
        :icon="iconClass"
        :list="children || []"
        :cat-id="id"
        :menu-name="menuName"
      />
      <li
        v-if="acl && menuName !== 'user'"
        class="mobileMenu__listItem mobileMenu__listItem--switch"
      >
        <div class="mobileMenu__listLink mobileMenu__listLink--switch">
          {{ priceSetting.label }}
        </div>
        <form-switch
          :value="acl.showNetPrices"
          name="mobileMenuSwitch"
          :disabled="priceSetting.readOnly"
          class="mobileMenu__switch"
          @input="
            onSwitch(priceSetting.id, priceSetting.groupIndex, priceSetting.settingsIndex, $event)
          "
        >
        </form-switch>
      </li>
      <li class="mobileMenu__listItem">
        <button class="mobileMenu__listLink" @click="$auth.logout()">
          <span class="mobileMenu__linkSpan">{{ loginLabel }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import MobileTreeMenu from './MobileTreeMenu';
import switchMixin from '~/mixins/switchPriceNet';
import FormMultiselect from '@/components/Form/FormMultiselect.vue';

export default {
  name: 'MobileMenu',
  components: {
    FormMultiselect,
    MobileTreeMenu,
  },
  mixins: [switchMixin],
  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },
    menuName: {
      type: String,
      default: 'category',
    },
    otherAccounts: {
      type: Array,
      default: () => [],
    },
    currentCompany: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState({
      isMenuOpened: state => state.layout.isMenuOpened,
      activeMenuItem: state => state.layout.activeMenuItem,
      user: state => state.auth.user,
    }),
    loginLabel() {
      return this.user?.login ? 'Wyloguj się' : 'Zaloguj się';
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: 'layout/toggleMenuOpened',
    }),
  },
};
</script>

<style lang="scss">
.mobileMenu {
  position: fixed;
  background-color: rgba($cBlack, 0.5);
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: $zPopup;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity $tr;

  &--active {
    opacity: 1;
    pointer-events: all;
    visibility: visible;
  }

  &__list {
    position: fixed;
    padding: 0 2rem 2rem 2rem;
    width: 350px;
    background-color: $cWhite;
    left: -350px;
    top: 0;
    height: 100%;
    overflow: hidden;
    transition: left 0.3s ease 0s;

    @include rwd('small-tablet') {
      width: 200%;
      left: 100%;
      padding-right: calc(100% + 2rem);
    }

    &--open {
      left: 0;
      overflow: auto;
    }

    &--parent {
      @include rwd('small-tablet') {
        left: -100%;
      }
    }
  }

  &__listItem {
    position: relative;

    &:first-of-type {
      margin-top: 1rem;
    }

    &--switch {
      display: flex;
      align-items: center;
    }
  }

  &__listLink {
    position: relative;
    margin: 2.2rem 0;
    display: flex;
    width: 100%;
    align-items: center;
    text-align: left;
    font-size: 1.8rem;
    line-height: 2.6rem;
    color: $cMainLight;

    &--switch {
      width: auto;
      margin: 0 2rem 0 0;
    }

    &--hasChild {
      padding-right: 4rem;
    }
  }

  &__listLinkCount {
    font-size: 1rem;
    background-color: $cSec;
    border-radius: 50%;
    color: $cWhite;
    font-weight: 700;
    margin-left: 1rem;
    padding: 0.3rem;
  }

  &__listChevron {
    position: absolute;
    padding: 1.6rem;
    right: -1.6rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: $cMainLight;
  }

  &__listIcon {
    width: 2.5rem;
    margin-right: 1.5rem;
    font-size: 1.5rem;
    color: $cAddDark02;
  }

  &__header {
    height: 6.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $cAddLight;
    font-size: 1.8rem;
    line-height: 2.3rem;
    font-weight: 600;
  }

  &__headerClose {
    position: relative;
    right: -5px;
    font-size: 1.5rem;
    color: $cMain;
    padding: 0.5rem;
  }

  &__headerPrev {
    font-size: 1.4rem;
    color: $cMainLight;
    padding: 0.8rem;
  }

  &__user {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 0 3rem 0;
    border-bottom: 1px solid $cAddLight;
  }

  &__select {
    margin-top: 1.5rem;
  }

  &__avatar {
    height: 5rem;
    width: 5rem;
    border-radius: 5px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('../static/images/avatar.png');
    margin-bottom: 1.5rem;
  }

  &__name {
    font-size: 1.8rem;
    line-height: 2.3rem;
    color: $cMainDark;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 600;

    span {
      color: $cAddDark02;
      font-size: 1.2rem;
      line-height: 1.5rem;
      font-weight: 400;
      margin-top: 0.3rem;
    }
  }

  &__linkSpan {
    position: relative;
  }

  &__itemLabel {
    position: absolute;
    left: calc(100% + 1.3rem);
    top: 50%;
    transform: translateY(-50%);
    width: 2rem;
    height: 2rem;
    padding-left: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    font-weight: 800;
    color: $cWhite;
    background-color: $cSec;
    border-radius: 50%;
  }

  &__listSearch {
    margin-top: 3rem;
  }
}
</style>
